/** Dark fade + "Leave Bed" button shown while the local player lies in a bed. */
export class SleepOverlay {
  private readonly el = document.createElement('div');
  private readonly btn = document.createElement('button');
  open = false;
  onLeave: (() => void) | null = null;

  constructor(root: HTMLElement = document.body) {
    this.el.style.cssText = 'position:fixed;inset:0;z-index:40;display:none;pointer-events:none;background:#000;opacity:0;';
    this.btn.textContent = 'Leave Bed';
    this.btn.style.cssText = 'position:fixed;left:50%;top:12%;transform:translateX(-50%);z-index:41;display:none;pointer-events:auto;'
      + 'min-width:200px;padding:10px 24px;font:16px monospace;color:#fff;background:#6b6b6b;border:2px solid #000;cursor:pointer;touch-action:manipulation;';
    const leave = (e: Event): void => { e.preventDefault(); e.stopPropagation(); this.onLeave?.(); };
    this.btn.addEventListener('click', leave);
    this.btn.addEventListener('touchend', leave);
    root.appendChild(this.el); root.appendChild(this.btn);
  }
  show(): void { this.open = true; this.el.style.display = 'block'; this.btn.style.display = 'block'; this.setFade(0); }
  hide(): void { this.open = false; this.el.style.display = 'none'; this.btn.style.display = 'none'; }
  /** 0 clear .. 1 dark (vanilla stops short of fully black). */
  setFade(f: number): void { this.el.style.opacity = String(Math.min(0.9, f * 0.9)); }
}
